import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'localization';

import { Flex, S } from 'design-system-web';
import { ServiceRequestData } from './FeedbackButton';

import styles from './ServiceRequestFeedbackDetails.scss';

const TRANSLATION_KEYS: { [key: string]: TranslationKeys } = Object.freeze({
  requestId: 'web.member.serviceRequest.feedbackModal.requestId',
  status: 'web.member.serviceRequest.feedbackModal.status',
  categoryIssue: 'web.member.serviceRequest.feedbackModal.categoryIssue',
  categoryIssueSeparator:
    'web.member.serviceRequest.feedbackModal.categoryIssueSeparator',
});

type ServiceRequestFeedbackDetailsProps = {
  serviceRequest: ServiceRequestData;
};

export const ServiceRequestFeedbackDetails = ({
  serviceRequest,
}: ServiceRequestFeedbackDetailsProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" className={styles.requestInfo}>
      <Flex justify="between" className={styles.infoRow}>
        <S className={styles.label}>{t(TRANSLATION_KEYS.requestId)}</S>
        <S className={styles.value}>{serviceRequest.userFriendlyID}</S>
      </Flex>
      <Flex justify="between" className={styles.infoRow}>
        <S className={styles.label}>{t(TRANSLATION_KEYS.status)}</S>
        <S className={styles.value}>{serviceRequest.status}</S>
      </Flex>
      <Flex justify="between" className={styles.infoRow}>
        <S className={styles.label}>{t(TRANSLATION_KEYS.categoryIssue)}</S>
        <S className={styles.value}>
          {serviceRequest.category}
          {t(TRANSLATION_KEYS.categoryIssueSeparator)}
          {serviceRequest.issue}
        </S>
      </Flex>
    </Flex>
  );
};
